import React, {useEffect} from "react";
import styles from "./modalBackdrop.module.scss";

export default function ModalBackdrop({onClick}) {

    useEffect(() => {
        document.body.classList.add('overflow-hidden');
        return () => document.body.classList.remove('overflow-hidden');
    }, [])

    return (
        <div onClick={onClick} className={styles.backdrop}/>
    );
}